import { useEffect, useState } from "react"
import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import Card from "@mui/material/Card"
import LinearProgress from "@mui/material/LinearProgress"
import Typography from "@mui/material/Typography"
import { useConnection } from "@solana/wallet-adapter-react"
import { PublicKey } from "@solana/web3.js"
import collection from "./data/collection.json"

export const MINT_URL = "https://mint.boredapepastelclub.com"

const CANDY_MACHINE = new PublicKey("Ck23wPGu5zi5Hwc65duUGM4cM68BY28774HVkmZgVEpz")

// CMv2 account layout: discriminator(8) authority(32) wallet(32) token_mint Option<Pubkey>(1 or 33) items_redeemed u64
const itemsRedeemed = (d: Uint8Array) => Number(new DataView(d.buffer, d.byteOffset, d.byteLength).getBigUint64(72 + (d[72] ? 33 : 1), true))

const MintStatus = () => {
	const { connection } = useConnection()
	const [minted, setMinted] = useState<number>()

	useEffect(() => {
		connection.getAccountInfo(CANDY_MACHINE)
			.then(acc => acc && setMinted(itemsRedeemed(acc.data)))
			.catch(() => setMinted(undefined))
	}, [connection])

	if (minted === undefined) return null
	return (
		<Card sx={{ maxWidth: 520, mx: "auto", mt: 5, p: 3, textAlign: "left" }}>
			<Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", flexWrap: "wrap", gap: 1 }}>
				<Typography sx={{ fontSize: "1.5rem", fontWeight: 700 }}>
					{minted} <Box component="span" sx={{ fontSize: "1rem", fontWeight: 400, color: "text.secondary" }}>/ {collection.total} minted</Box>
				</Typography>
				<Typography color="secondary.main" sx={{ fontWeight: 600 }}>{collection.total - minted} still available to mint</Typography>
			</Box>
			<LinearProgress variant="determinate" value={minted / collection.total * 100} aria-label="Minted"
				sx={{ mt: 2, height: 10, borderRadius: 5, bgcolor: "rgba(79,168,156,.15)" }} />
			{minted < collection.total && (
				<Button href={MINT_URL} target="_blank" rel="noopener" variant="contained" color="secondary" fullWidth sx={{ mt: 2.5, borderRadius: 999 }}>
					Mint now
				</Button>
			)}
		</Card>
	)
}

export default MintStatus
